import React, { FC } from 'react';
import { Typography } from 'antd';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CompanyTypeTitle from '~/layouts/CompanyTypeTitle';
import paths from '~/pages/paths';
import { Button, UnorderedList } from '~/components';
import colors from '~/constants/colors';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import SignConsent from '~/components/views/consent';

const CardHolderConsent: FC = () => {
  const history = useHistory();
  const scrollToTopRef = useRefScrollTo();
  const { t } = useTranslation();

  return (<SignConsent /> )
};

const Container = styled.div`
  .CompanyInformationSuccess-Paragraph {
    margin-bottom: 40px;
  }
  .CompanyInformationSuccess-Button {
    margin-bottom: 35px;
  }
  .UnorderedList {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    color: ${colors.disabledBlueTextColor};
  }
`;

export default CardHolderConsent;
